<template>
  <div class="container">
    <b-tabs v-model="activeTab">
      <b-tab-item label="Products">
        <admin-products></admin-products>
      </b-tab-item>
      <b-tab-item label="Photo Galleries">
        <admin-gallery></admin-gallery>
      </b-tab-item>
      <b-tab-item label="Categories">
        <admin-categories></admin-categories>
      </b-tab-item>
      <b-tab-item label="Menus">
        <menus></menus>
      </b-tab-item>
      <b-tab-item label="Pages">
        <admin-pages></admin-pages>
      </b-tab-item>
      <b-tab-item label="Users">
        <admin-users></admin-users>
      </b-tab-item>

    </b-tabs>
  </div>
</template>

<script>
import Menus from './Menus';
import AdminPages from './AdminPages';
import AdminUsers from './AdminUsers';
import AdminProducts from './AdminProducts';
import AdminCategories from './AdminCategories';
import AdminGallery from './AdminGallery';
import BTabs from 'buefy/src/components/tabs/Tabs';
import BTabItem from 'buefy/src/components/tabs/TabItem';

export default {
  components: {
    BTabItem,
    BTabs,
    AdminCategories,
    AdminProducts,
    AdminUsers,
    AdminPages,
    AdminGallery,
    Menus,
  },

  name: 'admin',

  data() {
    return {
      activeTab: 0,
    };
  },

  created() {
    if (this.user !== null && !this.user.is_admin) {
      this.$router.replace('/');
    }
  },

  watch: {
    user() {
      if (this.user === null || !this.user.is_admin) {
        this.$router.replace('/');
      }
    },

    activeTab() {
      this.$router.push({ name: 'Admin', params: { active_tab: this.activeTab } });
    },

    $route() {
      this.activeTab = this.$route.params.active_tab;
    },
  },

  computed: {
    page() {
      return this.$route.params.page;
    },

    user() {
      return this.$store.state.auth.user;
    },
  },

  mounted() {
    this.activeTab = this.$route.params.active_tab;
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/Admin.vue